// utils/DataService.js

import {
  getRetreatData,
  saveGroup,
  updateGroupStatus,
  getNewRegistrationStatus,
  getRegistrationCounts,
} from "../../services/RetreatServices";
class EventSupport {
  // Fetch event data by ID (for example purposes, can be extended to call real API)
  static async fetchEventData(eventID) {
    const eventsPath =
      process.env.REACT_APP_EVENTS_SOURCE || "source/events.json";
    const events = require(`../../${eventsPath}`);
    // Fetch event details based on retreatID
    console.log("Fetching event details for retreatID:", eventID);
    const retreatDetails = events.find((event) => event.id === eventID);
    if (!retreatDetails) {
      throw new Error("Retreat not found.");
    }
    console.log("Retreat details found:", retreatDetails);
    return retreatDetails;
  }

  // Fetch group data (for example purposes, can be extended to call real API)
  static async fetchGroupData(id, userEmail, userData, mode, registrationID) {
    try {
      console.log("EventSupport Fetching group data for userData:", userData);
      console.log("EventSupport Fetching group data for retreatID:", id);
      console.log("EventSupport Fetching group data for userEmail:", userEmail);
      console.log("EventSupport Fetching group data for mode:", mode);
      const retreatID = id;
      if (retreatID && userEmail && userData) {
        const response = await getRetreatData(
          retreatID,
          userEmail,
          userData,
          mode,
          registrationID
        );
        console.log("\n # EventSupport response fetched:", response);
        if (!response) {
          throw new Error("Failed to fetch group data");
        } else {
          let groupInfo = response;
          console.log(" ## EventSupport response :", response);
          if (groupInfo) {
            console.log(
              " ## 1 EventSupport numberOfParticipants :",
              groupInfo.numberOfParticipants
            );
            groupInfo.updatedBy = userData?.userID;
            groupInfo.numberOfParticipants = EventSupport.calculateParticipants(
              groupInfo.groupMembers
            );
            console.log(
              " ## 2 EventSupport numberOfParticipants :",
              groupInfo.numberOfParticipants
            );
          }

          console.log(" ### EventSupport groupInfo return:", groupInfo);
          return groupInfo;
        }
      }
    } catch (error) {
      throw new Error("Failed to fetch group data. Retry Again");
    }
  }

  // Calculate total participants from group members
  static calculateParticipants(groupMembers) {
    return groupMembers.filter((member) => !member.deleted).length;
  }

  static countMembersByAge(members) {
    const counts = {
      adults: 0,
      youngAdults: 0,
      teens: 0,
      children: 0,
      toddlers: 0,
    };

    members
      .filter((member) => !member.deleted)
      .forEach((person) => {
        if (person.age >= 19) {
          counts.adults++;
        } else if (person.age >= 16 && person.age <= 18) {
          counts.youngAdults++;
        } else if (person.age >= 13 && person.age <= 15) {
          counts.teens++;
          // } else if (person.age >= 7) {
        } else if (person.age >= 5 && person.age <= 12) {
          counts.children++;
        } else {
          counts.toddlers++;
        }
      });

    return counts;
  }
  static calculateAmount(groupInfo) {
    if (!groupInfo) return 0; // Return 0 if no data is available

    console.log("Calculating total amount...");
    const eventsPath =
      process.env.REACT_APP_EVENTS_SOURCE || "source/events.json";
    const events = require(`../../${eventsPath}`);
    const eventDetails = events.find(
      (event) => event.id === groupInfo.retreatID
    );
    if (!eventDetails) {
      //throw new Error("Retreat not found.");
      return 0;
    }

    let updatedMembers = groupInfo.groupMembers
      ? groupInfo.groupMembers.filter((member) => !member.isDeleted)
      : [];

    console.log("Updated members:", updatedMembers);

    const rooms = Math.max(parseInt(groupInfo.rooms, 10) || 1, 1);
    const roomShare = groupInfo.shareRoom || false;

    const counts = EventSupport.countMembersByAge(updatedMembers);
    console.log("counts :", counts);

    const nOfAdults = counts.adults;
    const nOfTeens = counts.teens;
    const nOfChildren = counts.children;
    const nOfToddlers = counts.toddlers;
    const nOfYoungAdults = counts.youngAdults;

    const roomBasePrice = eventDetails.roomBasePrice || 0;
    const childRate = eventDetails.childRate || 0;
    const teenRate = eventDetails.teenRate || 0;
    const youngAdultRate = eventDetails.youngAdultRate || 0;
    const additionalAdultRate = eventDetails.additionalAdultRate || 0;
    const adultRetreatRate = eventDetails.adultRetreatRate || 0;

    console.log("Room base price:", roomBasePrice);
    console.log("adultRetreatRate:", adultRetreatRate);
    let totalCost =
      nOfAdults * adultRetreatRate +
      nOfYoungAdults * youngAdultRate +
      nOfChildren * childRate +
      nOfTeens * teenRate +
      nOfToddlers * eventDetails.toddlerRate;

    console.log("Total Retreat cost:", totalCost);
    if (eventDetails.type === "Residential") {
      let totalRoomCost = roomBasePrice * rooms;
      if (roomShare) {
        totalRoomCost += EventSupport.calculateShareCost(
          nOfAdults,
          nOfYoungAdults,
          nOfTeens,
          nOfChildren,
          childRate,
          additionalAdultRate
        );
      } else {
        totalRoomCost += EventSupport.calculateNonShareCost(
          nOfAdults,
          nOfYoungAdults,
          nOfTeens,
          nOfChildren,
          childRate,
          additionalAdultRate
        );
      }
      totalCost = totalCost + totalRoomCost;
    }

    console.log("Total cost calculated (room & retreat):", totalCost);
    return Math.max(totalCost, 0);
  }

  static calculateShareCost(
    nOfAdults,
    nOfYoungAdults,
    nOfTeens,
    nOfChildren,
    childRate,
    additionalAdultRate
  ) {
    console.log("Calculating share cost...");
    if (nOfAdults === 1) {
      return nOfChildren > 0 ? (nOfChildren - 1) * childRate : 0;
    }
    return (nOfAdults - 2) * additionalAdultRate + nOfChildren * childRate;
  }

  static calculateNonShareCost(
    nOfAdults,
    nOfYoungAdults,
    nOfTeens,
    nOfChildren,
    childRate,
    additionalAdultRate
  ) {
    console.log("Calculating non-share cost...");
    let cost = 0;
    if (nOfAdults === 1) {
      cost += nOfChildren > 0 ? (nOfChildren - 1) * childRate : 0;
    } else {
      cost += (nOfAdults - 2) * additionalAdultRate + nOfChildren * childRate;
    }
    console.log("Non-share cost calculated:", cost);
    return cost;
  }

  static calculateAndApplyStripeFees(amount, eventData) {
    // Stripe fees: 2.9% + $0.30 per transaction
    const percentageFee = eventData.stripe_percentage
      ? parseFloat(eventData.stripe_percentage) / 100
      : 0.029;
    const fixedFee = eventData.stripe_fixed_amount
      ? parseFloat(eventData.stripe_fixed_amount)
      : 0.3;
    const totalFees = amount * percentageFee + fixedFee;
    const totalAmount = amount + totalFees;
    console.log("Original amount:", amount);
    console.log("Stripe fees:", totalFees);
    console.log("Total amount with fees:", totalAmount);
    return Math.round(totalAmount * 100) / 100; // Round to 2 decimal places
  }

  static async saveGroupData(groupData, saveMode) {
    //console.log("RetreatSupport Saving group data...", groupData);
    console.log("RetreatSupport saveMode:", saveMode);
    try {
      const response = await saveGroup(groupData, saveMode);
      console.log("Group data saved successfully:", response);
      return response;
    } catch (err) {
      console.error("Error saving group data:", err);
      console.log("err.response?.data :", err.response?.data);
      console.log("err.message:", err.message);
      //let error = err.response?.data ? err.response.data : err.message || "Error saving Registration";
      throw err;
    }
  }

  static async updateGroupStatus(groupData, status) {
    console.log("RetreatSupport updateGroupStatus group data...", groupData);
    console.log("RetreatSupport updateGroupStatus status...", status);
    try {
      const response = await updateGroupStatus(groupData, status);
      console.log("Group updateGroupStatus successfully:", response);
      return response;
    } catch (error) {
      console.error("Error saving group data:", error);
    }
  }

  static async canRegisterEvent(eventData) {
    const currentDate = new Date();
    const regDate = eventData.reg_date;
    const startDate = eventData.reg_end_date
      ? eventData.reg_end_date
      : eventData.start_date;
    const id = eventData.id;
    const maxCount = eventData.maxRegistrationCount;

    let canRegister =
      new Date(regDate) <= currentDate && currentDate <= new Date(startDate);

    if (canRegister) {
      try {
        const totalCount = await getRegistrationCounts(id);

        console.log("canRegister 1:", canRegister);
        canRegister = maxCount > 0 && totalCount < maxCount ? true : false;
        console.log("canRegister 2:", canRegister);
      } catch (error) {
        console.error("Error in canRegister:", error);
        return canRegister;
      }
    }
    return canRegister;
  }

  static async getNewRegistrationStatus(eventData) {
    const currentDate = new Date();
    const regDate = eventData.reg_date;
    const startDate = eventData.reg_end_date
      ? eventData.reg_end_date
      : eventData.start_date;
    const id = eventData.id;
    const maxCount = eventData.maxRegistrationCount;

    let canRegister =
      new Date(regDate) <= currentDate && currentDate <= new Date(startDate);

    if (canRegister) {
      try {
        return await getNewRegistrationStatus(id);
      } catch (error) {
        console.error("Error in getNewRegistrationStatus:", error);
        return "Draft"; // Default to "Draft" if there's an error
      }
    }
    return "Draft";
  }
}

export default EventSupport;
